module.exports = __webpack_public_path__ + "fk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/fk.svg
// module id = 546
// module chunks = 0